import type {
  PositionValue,
  PositionWithOffsetValue
} from '@elfsight/configurator-contracts';

export function transformMixin(_position: PositionWithOffsetValue['position']) {
  const transformOptions: Partial<Record<PositionValue, string>> = {
    top: `transform: translateX(50%)`,
    bottom: `transform: translateX(50%)`,
    left: `transform: translateY(50%)`,
    right: `transform: translateY(50%)`
  };

  return transformOptions[_position];
}
